module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_sentrert_logo_stor_pos.cbce7fcf.svg";